/**
 * Entorno de PRUEBAS (`ng build --configuration staging`).
 *
 * Apunta al proyecto Firebase `private-club-staging`, que es independiente de producción:
 * otra base Firestore, otro pool de Auth, otro bucket de Storage, otros secretos y su
 * propio stream de GA4. Ver docs/wiki/environments.md.
 *
 * `measurementId` está vacío a propósito: el proyecto todavía no tiene una propiedad de
 * Google Analytics enlazada. Mientras siga vacío, `isAnalyticsEnabled()` deja Analytics
 * apagado en pruebas. Para encenderlo: Consola de Firebase → Analytics → enlazar una
 * propiedad GA4, y pegar aquí el `measurementId` (`G-…`) que aparezca en la configuración
 * de la app web.
 */

import type { Environment } from './environment.model';

export const environment: Environment = {
  envName: 'staging',
  production: true,
  useEmulators: false,
  useAnalyticsInDev: false,
  firebase: {
    apiKey: 'AIzaSyBt3CPxhuQKbZ0IEzOsM5FVGl3j8jmgJt8',
    authDomain: 'private-club-staging.firebaseapp.com',
    projectId: 'private-club-staging',
    storageBucket: 'private-club-staging.firebasestorage.app',
    messagingSenderId: '322589784993',
    appId: '1:322589784993:web:5c4d34a6ef1b1f799569e0',
    measurementId: '',
  },
};
